import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  loginPageInfo: {
    email: "",
    password: "",
  },
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
    },
    saveLoginInfo: (state, action) => {
      const { email, password } = action.payload;
      state.loginPageInfo = { email, password };
    },
  },
});

export const { logout, setCredentials, saveLoginInfo } = slice.actions;

export default slice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectLoginInfo = (state) => state.auth.loginPageInfo;
